import { push } from '@lagunovsky/redux-react-router'
import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { H_CAMPAIGN_HYDRO_DASHBOARD } from '../../../account/constants/AccessRulesConstants'
import CampaignAction from '../../../campaign/actions/CampaignAction'
import DashboardCampaign from '../../../campaign/components/campaignDashboard/DashboardCampaign'
import ProgressCard from '../../../components/card/ProgressCard'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import { useParams } from 'react-router'
import { STATION_TYPE_NAME } from 'station/constants/StationConstants'

const HydrometryCampaignDashboard = ({}) => {
    const [dataLoaded, setDataLoaded] = useState(false)
    const [progress, setProgress] = useState(0)

    const {
        hydrometricStations,
    } = useSelector(store => ({
        hydrometricStations: store.HydrometryReducer.hydrometricStations,
    }), shallowEqual)

    const { id } = useParams()
    const dispatch = useDispatch()

    useEffect(() => {
        if (!componentHasHabilitations(H_CAMPAIGN_HYDRO_DASHBOARD)) { // A modifier quand react-router sera à jour
            dispatch(push('/unauthorized'))
            return
        }
        dispatch(CampaignAction.loadCampaignDashboard(p => setProgress(p)))
            .then(() => setDataLoaded(true))
    }, [dispatch, id])

    if (dataLoaded) {
        return (
            <DashboardCampaign
                stations={hydrometricStations}
                stationType={STATION_TYPE_NAME.hydrometry}
            />
        )
    }
    return <ProgressCard progress={progress} />
}

export default HydrometryCampaignDashboard
